import React, { FC } from 'react'
import { Spacer } from 'components/Utility'
import { ErrorMessage } from 'components/Error'
import { isNumerics, isValidPhoneNumber, isValidUrlString } from 'lib/validator'
import equal from 'fast-deep-equal'

type Props = {
  imageUrls: string[]
  name: string
  nameKana: string
  firstPostalCode: string
  secondPostalCode: string
  state: string
  city: string
  street: string
  phoneNumber: string
  hasEatingArea: string
  status: string
  homepage: string
  twitter: string
  instagram: string
  facebook: string
  line: string
}

const StoreInfoError: FC<Props> = React.memo(
  (props) => {
    const {
      imageUrls,
      name,
      nameKana,
      firstPostalCode,
      secondPostalCode,
      state,
      city,
      street,
      phoneNumber,
      hasEatingArea,
      status,
      homepage,
      twitter,
      instagram,
      facebook,
      line,
    } = props
    return (
      <div>
        {imageUrls.length === 0 && (
          <>
            <ErrorMessage caution={`店舗画像を選択してください。`} id={'image'} />
            <Spacer size={12} />
          </>
        )}
        {name === '' && (
          <>
            <ErrorMessage caution={`店名を入力してください。`} id={'name'} />
            <Spacer size={12} />
          </>
        )}
        {nameKana === '' && (
          <>
            <ErrorMessage caution={`フリガナを入力してください。`} id={'name-kana'} />
            <Spacer size={12} />
          </>
        )}
        {(firstPostalCode === '' || secondPostalCode === '') && (
          <>
            <ErrorMessage caution={`郵便番号を入力してください。`} id={'postal-code'} />
            <Spacer size={12} />
          </>
        )}
        {(!isNumerics(firstPostalCode) || !isNumerics(secondPostalCode)) && (
          <>
            <ErrorMessage caution={`郵便番号を数字で入力してください。`} id={'postal-code'} />
            <Spacer size={12} />
          </>
        )}
        {(state === '' || city === '' || street === '') && (
          <>
            <ErrorMessage caution={`住所を入力してください。`} id={'address'} />
            <Spacer size={12} />
          </>
        )}
        {!isValidPhoneNumber(phoneNumber) && (
          <>
            <ErrorMessage caution={`電話番号を正しい形式で入力してください。`} id={'phone-number'} />
            <Spacer size={12} />
          </>
        )}
        {hasEatingArea === '' && (
          <>
            <ErrorMessage caution={`イートインスペースの有無を選択してください。`} id={'eat-in'} />
            <Spacer size={12} />
          </>
        )}
        {status === '' && (
          <>
            <ErrorMessage caution={`公開状況を選択してください。`} id={'status'} />
            <Spacer size={12} />
          </>
        )}
        {!isValidUrlString(homepage) && (
          <>
            <ErrorMessage caution={`お店のホームページのURLを正しい形式で入力してください。`} id={'homepage'} />
            <Spacer size={12} />
          </>
        )}
        {!isValidUrlString(twitter) && (
          <>
            <ErrorMessage caution={`お店のtwitterのURLを正しい形式で入力してください。`} id={'twitter'} />
            <Spacer size={12} />
          </>
        )}
        {!isValidUrlString(instagram) && (
          <>
            <ErrorMessage caution={`お店のinstagramのURLを正しい形式で入力してください。`} id={'instagram'} />
            <Spacer size={12} />
          </>
        )}
        {!isValidUrlString(facebook) && (
          <>
            <ErrorMessage caution={`お店のfacebookのURLを正しい形式で入力してください。`} id={'facebook'} />
            <Spacer size={12} />
          </>
        )}
        {!isValidUrlString(line) && (
          <>
            <ErrorMessage caution={`お店のLINEアカウントのURLを正しい形式で入力してください。`} id={'line'} />
            <Spacer size={12} />
          </>
        )}
      </div>
    )
  },
  (prev, next) => equal(prev, next)
)

export default StoreInfoError
